// profile page
import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, combineReducers, bindActionCreators } from 'redux';
import { connect, Provider } from 'react-redux';
import { ThemeProvider } from '@workboard/wobo-ui';
import ProfileConst from './constants/profile.constants';
import ProfileReducer from './reducers/profile.reducers';
import * as ProfileActions from './actions/profile.actions';
import PreferenceApp from './components/preferences/preferences.component';


const mapsStateToPropsProfile = state => ({
  preferenceData: state,
});

const mapsDispatchToPropsProfile = dispatch => ({
  actions: bindActionCreators(ProfileActions, dispatch),
});

const PreferenceAppComp = connect(mapsStateToPropsProfile, mapsDispatchToPropsProfile)(PreferenceApp);

const initPreferenceComp = function (data) {
  // console.log('initPreferenceComp----------->');
  // console.log(data);
  const profileStore = createStore(ProfileReducer, data);
  ReactDOM.render(
    <Provider store={profileStore}>
      <ThemeProvider>
        <PreferenceAppComp />
      </ThemeProvider>
    </Provider>,
    document.getElementById('userPreferenceComp'),
  );
};

window.initPreferenceComp = initPreferenceComp;
